import { CheckIcon } from "@heroicons/react/solid";
import Tooltip from "../../components/Tooltip/Tooltip";

const VerifiedIcon = () => {
  return (
    <>
      <figure
        data-tip
        data-for="tooltip"
        className="rounded-[50%] bg-[#739CFF] w-5 h-5"
      >
        <CheckIcon className="w-full h-full p-[2rem] text-white" />
      </figure>

      <Tooltip id="tooltip" effect="solid">
        The creator is a verified admin of this community.
      </Tooltip>
    </>
  );
};

export default VerifiedIcon;
